import { ContentType, request } from "../api";
import { baseParams } from "../common";

/**
 * Дополнительные услуги к заказу (eSIM, багаж и т.п.). Каталог и цены считает бек:
 * { options: [{ additional_option_id, type, name, items: [{ code, name, description, price, currency, per, max_quantity }] }], warnings }
 */
export const getAdditionalOptions = async (data = {}, params = {}) => request({
  path: "/additional-options",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  secure: true,
  ...params,
});

/**
 * Зафиксировать выбор в заказе (полный список; пустой options — снять всё):
 * { order_id, session_id, options: [{ additional_option_id, code, quantity }] }
 */
export const selectAdditionalOptions = async (data = {}, params = {}) => request({
  path: "/additional-options/select",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  secure: true,
  ...params,
});
